import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const LS_KEY = "pref_confirm_shift_cancel"; // local cache for instant UX

export function useUserPreferences() {
  const [confirmShiftCancel, setConfirmShiftCancelState] = useState<boolean>(() => {
    const ls = localStorage.getItem(LS_KEY);
    return ls === null ? true : ls === "true";
  });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase.rpc("get_user_preferences");
    if (!error && data) {
      const enabled = Boolean(data.confirm_shift_cancel);
      setConfirmShiftCancelState(enabled);
      localStorage.setItem(LS_KEY, String(enabled));
    }
    setLoading(false);
  }, []);

  const setConfirmShiftCancel = useCallback(async (enabled: boolean) => {
    setConfirmShiftCancelState(enabled);
    localStorage.setItem(LS_KEY, String(enabled));
    const { error } = await supabase.rpc("set_confirm_shift_cancel", { p_enabled: enabled });
    if (error) {
      // rollback on failure
      setConfirmShiftCancelState(!enabled);
      localStorage.setItem(LS_KEY, String(!enabled));
      throw error;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { confirmShiftCancel, setConfirmShiftCancel, loading, refresh };
}
